import type { VerificationTypeOption } from '@/types/general/verification';

export enum VerificationType {
  WHATSAPP = 'whatsapp',
  SMS = 'sms'
}

export const verificationTypeOptions = [
  { label: 'WhatsApp', value: VerificationType.WHATSAPP },
  { label: 'SMS', value: VerificationType.SMS }
];

export const verificationTypeMapper = (verificationType: VerificationType | undefined): VerificationTypeOption | undefined => {
  if (typeof verificationType != undefined) {
    return verificationTypeOptions.find((optionItem: VerificationTypeOption) => {
      return optionItem.value === verificationType;
    });
  }
};

export const verificationTypeMapByValue = (value: string | undefined): VerificationType | undefined => {
  if (value == VerificationType.SMS) {
    return VerificationType.SMS;
  } else if (value == VerificationType.WHATSAPP) {
    return VerificationType.WHATSAPP;
  }
};
